import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    pageName:"網站導覽",
    path: '/guide',
    name: 'guide',
    component: () => import('../views/guide.vue'),
  },
  {
    pageName:"最新消息",
    path: '/newsMessageAll',
    name: 'NewsMessageAll',
    component: () => import('../views/newsMessageAll.vue'),
  },
  {
    //最新消息的內容
    path: '/newsContent',
    name: 'newsContent',
    component: () => import('../views/newsContent.vue'),
    props: true
  },
  {
    pageName:"最新消息",
    path: '/mediaMessageAll',
    name: 'mediaMessageAll',
    component: () => import('../views/mediaMessageAll.vue'),
  },
  {
    path: '/mediaContent',
    name: 'mediaContent',
    component: () => import('../views/mediaContent.vue'),
    props: true
  },
  {
    pageName:"學程簡介",
    path: '/intro',
    name: 'intro',
    component: () => import('../views/intro.vue')
  },
  {
    pageName:"課程資訊",
    path: '/class',
    name: 'class',
    component: () => import('../views/class.vue'),
  },
  {
    pageName:"就業出路",
    path: '/job',
    name: 'job',
    component: () => import('../views/job.vue')
  },
  {
    pageName:"團隊成員",
    path: '/teamMember',
    name: 'teamMember',
    component: () => import('../views/teamMember.vue'),
    props: true
  },
  {
    pageName:"師資介紹",
    path: '/fulltime',
    name: 'fulltime',
    component: () => import('../views/fulltime.vue')
  },
  {
    pageName:"行政人員",
    path: '/staff',
    name: 'staff',
    component: () => import('../views/staff.vue')
  },
  {
    pageName:"實驗空間",
    path: '/room',
    name: 'room',
    component: () => import('../views/room.vue'),
    props: true
  },
  {
    pageName:"實驗設備",
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/equipment.vue'),
    props: true
  },
  {
    pageName:"高中專區",
    path: '/highschool',
    name: 'highschool',
    component: () => import('../views/highschool.vue'),
    props: true
  },
  {
    //活動紀錄的內容
    path: '/content',
    name: 'content',
    component: () => import('../views/content.vue'),
    props: true
  },
  {
    pageName:"自主學習",
    path: '/learn',
    name: 'learn',
    component: () => import('../views/learn.vue'),
  },
  {
    pageName:"相關法規",
    path: '/regulation',
    name: 'regulation',
    component: () => import('../views/regulation.vue')
  },
  {
    pageName:"招生資訊",
    path: '/enrollment',
    name: 'enrollment',
    component: () => import('../views/enrollment.vue')
  },
  {
    pageName:"學分抵免",
    path: '/credit',
    name: 'credit',
    component: () => import('../views/credit.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})


export default router
